module.exports = "<div data-component=\"summary\" class=\"step\" *ngIf=\"active\">\n\n\t<app-warning [message]=\"renameAccountData.message\" [type]=\"renameAccountData.success ? 'success' : 'error'\"></app-warning>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/summary/summary.component.html
// module id = ../../../../../src/app/master/rename-your-account/summary/summary.component.html
// module chunks = main